import { MathUtil } from './../utils/MathUtil';
import { DisplayObjectUtil } from './../utils/DisplayObjectUtil';
import { Physics } from './Physics';

export class PhysicsDebugDraw {

    private circleVertices: Array<number> = [];
    private particleVertices: Array<number> = [];

    private circleResolution: number = 8;
    private particleResolution: number = 3;

    private _graphics:PIXI.Graphics;

    public color:number = 0xFFFF00;

    constructor(public physcis: Physics) {
        this._graphics = new PIXI.Graphics();
        this._graphics.scale.set(physcis.b2Scale, physcis.b2Scale);
        this.initCircleVertices(this.circleVertices, this.circleResolution);
        this.initCircleVertices(this.particleVertices, this.particleResolution);
        var renderer: PhysicsDebugDraw = this;
        
       b2CircleShape.prototype.draw = function (transform: b2Transform): void {
            var circlePosition = this.position,
                center = new b2Vec2(circlePosition.x, circlePosition.y);
            renderer.insertCircleVertices(transform, this.radius, center.x, center.y);
        };

        b2ChainShape.prototype.draw = function (transform: b2Transform) {
            renderer.transformVerticesAndInsert(this.vertices, transform);
        };

        b2EdgeShape.prototype.draw = function (transform) {
            renderer.transformAndInsert(this.vertex1, this.vertex2, transform);
        };

        b2PolygonShape.prototype.draw = function (transform) {
            renderer.transformVerticesAndInsert(this.vertices, transform, true);
        };
    }

    public get graphics():PIXI.Graphics {
        return this._graphics;
    }

    public dispose():void {
        this._graphics.clear();
        DisplayObjectUtil.removeFromParent(this._graphics);
    }

    private initCircleVertices = function (v: Array<number>, resolution: number) {
        var size = MathUtil.TWO_PI / resolution;

        for (var i = 0; i < resolution; i++) {
            var s1 = (i * size);
            var s2 = ((i + 1) * size);

            v.push(Math.cos(s1));
            v.push(Math.sin(s1));
            v.push(Math.cos(s2));
            v.push(Math.sin(s2));
        }
    }
    private transformAndInsert(v1, v2, transform) {
        var transformedV1 = new b2Vec2(),
            transformedV2 = new b2Vec2();

        b2Vec2.Mul(transformedV1, transform, v1);
        b2Vec2.Mul(transformedV2, transform, v2);
        this.insertLine(transformedV1, transformedV2);
    }
    private transformVerticesAndInsert(vertices: Array<b2Vec2>, transform: b2Transform, closeShape:boolean = false) {
        var vertexCount = vertices.length;

        for (var i = 1; i < vertexCount; i++) {
            this.transformAndInsert(vertices[i - 1], vertices[i], transform);
        }
        if(closeShape) {
            this.transformAndInsert(vertices[vertexCount - 1], vertices[0], transform);
        }
    }

    private insertCircleVertices(transform: b2Transform, radius: number, x: number, y: number) {
        var vertices = this.circleVertices;
        for (var i = 0; i <= this.circleResolution; ++i) {
            var i4 = i * 4;
            var v1 = new b2Vec2(vertices[i4] * radius + x, vertices[i4 + 1] * radius + y);
            var v2 = new b2Vec2(vertices[i4 + 2] * radius + x, vertices[i4 + 3] * radius + y);

            b2Vec2.Mul(v1, transform, v1);
            b2Vec2.Mul(v2, transform, v2);

            if(i == 0) {
                let center:b2Vec2 = new b2Vec2(x, y);
                b2Vec2.Mul(center, transform, center);
                this.insertLine(center, v1);
            }

            this.insertLine(v1, v2);
        }
    }

    private insertLine(v1: b2Vec2, v2: b2Vec2): void {
        this.graphics.moveTo(v1.x, v1.y);
        this.graphics.lineTo(v2.x, v2.y);
    }

    private insertLine2(v1x: number, v1y: number, v2x: number, v2y: number): void {
        this.graphics.moveTo(v1x, v1y);
        this.graphics.lineTo(v2x, v2y);
    }

    private insertParticleVertices(radius, x, y) {
        var vertices = this.particleVertices;
        for (var i = 0; i < this.particleResolution; i++) {
            var i4 = i * 4;
            var x1 = vertices[i4] * radius + x;
            var y1 = vertices[i4 + 1] * radius + y;
            var x2 = vertices[i4 + 2] * radius + x;
            var y2 = vertices[i4 + 3] * radius + y;

            this.insertLine2(x1, y1, x2, y2);
        }
    }

    private drawParticleSystem(system: b2ParticleSystem) {
        var particles = system.GetPositionBuffer();
        var maxParticles = particles.length,
            transform = new b2Transform();
        transform.SetIdentity();

        for (var i = 0, c = 0; i < maxParticles; i += 2, c += 4) {
            this.insertParticleVertices(system.radius, particles[i], particles[i + 1]);
        }
    }

    public draw(): void {
        this.graphics.clear();
        this.graphics.lineStyle(1 / this.physcis.b2Scale, this.color, 1);

        for (let i: number = 0, max: number = this.physcis.world.bodies.length; i < max; ++i) {
            var body = this.physcis.world.bodies[i];
            var maxFixtures = body.fixtures.length;
            var transform = body.GetTransform();
            for (var j = 0; j < maxFixtures; j++) {
                var fixture: b2Fixture = body.fixtures[j];
                fixture.shape.draw(transform);
            }
        }

        for (let i = 0, max = this.physcis.world.joints.length; i < max; i++) {
            //let joint:b2Joint = this.physcis.world.joints[i];
        }

        // draw particle systems
        for (let i = 0, max = this.physcis.world.particleSystems.length; i < max; i++) {
            this.drawParticleSystem(this.physcis.world.particleSystems[i]);
        }
    }
}


// WEBPACK FOOTER //
// ./src/framework/liquidfun/PhysicsDebugDraw.ts